module.exports = __webpack_public_path__ + "static/media/po-lub-1.7d81846b.png";